"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SDP_STALE_THRESHOLD_SECONDS = exports.DEVICE_SESSION_STALE_MS = exports.DEVICE_HEARTBEAT_INTERVAL_MS = void 0;
// How often a device writes a session heartbeat to Firestore
exports.DEVICE_HEARTBEAT_INTERVAL_MS = 15 * 60 * 1000; // 15 minutes
// Sessions older than this are considered stale (inactive device)
exports.DEVICE_SESSION_STALE_MS = 30 * 60 * 1000; // 30 minutes
// SDP printer is considered offline if no pull has been received within this window
exports.SDP_STALE_THRESHOLD_SECONDS = 600; // 10 minutes per ADR
//# sourceMappingURL=deviceActivity.js.map